import { Any, JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";
import { CashbackArrayCounter, Counters } from "../cashback/counters";

@JsonConverter
export class InvitationsListArrayConverter implements JsonCustomConvert<Array<InvitationsList>>{
    serialize() { }
    deserialize(data: any): Array<InvitationsList> {
        const jsonConvert: JsonConvert = new JsonConvert();
        return jsonConvert.deserializeArray(data, InvitationsList);
    }
}
@JsonConverter
export class InvitationsListConverter implements JsonCustomConvert<InvitationsList>{
    serialize() { }
    deserialize(data: any): InvitationsList {
        const jsonConvert: JsonConvert = new JsonConvert();
        return jsonConvert.deserializeObject(data, InvitationsList);
    }
}
@JsonConverter
export class InvitationsListCountConverter implements JsonCustomConvert<InvitationsListCount>{
    serialize() { }
    deserialize(data: any): InvitationsListCount {
        const jsonConvert: JsonConvert = new JsonConvert();
        return jsonConvert.deserializeObject(data, InvitationsListCount);
    }
}

@JsonObject("InvitationsList")
export class InvitationsList{
    @JsonProperty("id", String, true)
    id: string = "";
    @JsonProperty("email", String, true)
    email: string = "";
    @JsonProperty("created_at", Number, true)
    created_at: number = 0;
    @JsonProperty("type", String, true)
    type: string = "";
    @JsonProperty("status", String, true)
    status: string = "";
}

@JsonObject("InvitationsListCount")
export class InvitationsListCount {
    @JsonProperty("count", Number, true)
    count: number = 0;
    @JsonProperty("data", InvitationsListArrayConverter, true)
    data: Array<InvitationsList> = new Array<InvitationsList>();
}
@JsonObject("InvitationsListData")
export class InvitationsListData extends BaseResponse{
    @JsonProperty("data", InvitationsListCountConverter, true)
    data: InvitationsListCount = new InvitationsListCount();
}

@JsonObject("SingleInvitations")
export class SingleInvitations extends BaseResponse {
    @JsonProperty("data", InvitationsListConverter, true)
    data: InvitationsList = new InvitationsList();
}